<div class="grid-img-wrapper">
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="blobUrl; else notProvided">
      <img [src]="blobUrl" alt="image" class="logo-img" />
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="loading-icon">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </ng-template>

  <ng-template #notProvided>
    <span class="not-provided-span">Not Provided yet</span>
  </ng-template>
</div>
